import { useAppSelector } from '@/hooks/useAppSelector';

import { selectSecret } from '../services/selectors';
import type { Secret } from '../types';

export const useSecretDetail = (id: Secret['id']) => useAppSelector(state => selectSecret(state, { id }));
